/**
 * Türkiye Telefon Numarası Formatlama ve Doğrulama Yardımcıları
 */

/**
 * Kullanıcı girdisini standart Türkiye cep telefonu formatına dönüştürür.
 * Örnek: "05321234567" -> "0532 123 45 67"
 * Maksimum 11 hane (0 ile başlayan) veya 10 hane kabul eder, fazla sayıların yazılmasını engeller.
 */
export function formatTurkishPhoneNumber(input: string): string {
  if (!input) return '';

  // Sadece rakamları al
  let digits = input.replace(/\D/g, '');

  // Eğer kullanıcı +90 veya 90 ile başladıysa baştaki 90'ı kaldır veya 0'a dönüştür
  if (digits.startsWith('90') && digits.length > 2) {
    digits = digits.substring(2);
  }

  // Eğer kullanıcı 5 ile başladıysa başına 0 ekle (kullanıcı kolaylığı)
  if (digits.length > 0 && digits[0] !== '0') {
    digits = '0' + digits;
  }

  // Maksimum 11 hane ile sınırla (05XXXXXXXXX)
  if (digits.length > 11) {
    digits = digits.substring(0, 11);
  }

  // Adım adım formatlama (05XX XXX XX XX)
  if (digits.length <= 4) {
    return digits; // "0532"
  }
  if (digits.length <= 7) {
    return `${digits.slice(0, 4)} ${digits.slice(4)}`; // "0532 123"
  }
  if (digits.length <= 9) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`; // "0532 123 45"
  }
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 11)}`; // "0532 123 45 67"
}

/**
 * Telefon numarasının geçerli bir Türkiye cep telefonu olup olmadığını doğrular.
 */
export function validateTurkishPhoneNumber(phone: string): { isValid: boolean; error?: string; normalized: string } {
  const digits = phone.replace(/\D/g, '');

  if (!digits) {
    return { isValid: false, error: 'Lütfen telefon numaranızı giriniz.', normalized: '' };
  }

  // Normalize edilmiş format: 05XXXXXXXXX (11 hane)
  let normalized = digits;
  if (normalized.startsWith('90') && normalized.length === 12) {
    normalized = '0' + normalized.substring(2);
  } else if (!normalized.startsWith('0') && normalized.length === 10) {
    normalized = '0' + normalized;
  }

  // Türkiye cep numaraları: 050X, 051X, 052X, 053X, 054X, 055X, 056X, 057X, 058X, 059X
  if (!normalized.startsWith('05')) {
    return {
      isValid: false,
      error: 'Geçerli bir cep telefonu numarası giriniz (05XX ile başlamalıdır).',
      normalized,
    };
  }

  if (normalized.length !== 11) {
    return {
      isValid: false,
      error: `Telefon numarası eksik (${normalized.length}/11 hane). Örn: 0532 123 45 67`,
      normalized,
    };
  }

  return { isValid: true, normalized };
}
